// Meta Pixel event helper — safely fires fbq events if the pixel is loaded.
export const fbqTrack = (event, data = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", event, data);
    }
  } catch (e) {
    // no-op: never break UX because of tracking
  }
};
